import { useCallback, useEffect, useState } from 'react'

import { F0ButtonToggle } from '@factorialco/f0-react'
import { Microphone, MicrophoneNegative } from '@factorialco/f0-react/icons/app'
import { useLocalParticipant, usePersistentUserChoices } from '@livekit/components-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const MicrophoneButton = () => {
  const { userChoices, saveAudioInputEnabled } = usePersistentUserChoices()
  const { localParticipant } = useLocalParticipant()
  const [audioEnabled, setAudioEnabled] = useState(userChoices.audioEnabled)

  // Save settings when they change
  useEffect(() => {
    saveAudioInputEnabled(audioEnabled)
  }, [audioEnabled, saveAudioInputEnabled])

  const handleMicToggle = useCallback(async () => {
    try {
      const newState = !audioEnabled
      await localParticipant.setMicrophoneEnabled(newState)
      setAudioEnabled(newState)
    } catch (error) {}
  }, [audioEnabled, localParticipant])

  return (
    <F0ButtonToggle
      icon={audioEnabled ? Microphone : MicrophoneNegative}
      label={i18n.t('meetings.room.control_bar.microphone.label')}
      onSelectedChange={() => {
        track(trackingEvents.meetings.ControlBarMuteButton, {
          isMuted: !audioEnabled,
        })
        handleMicToggle()
      }}
      size="lg"
      selected={audioEnabled}
    />
  )
}
